import { render, staticRenderFns } from "./CallRecordingActionButtons.vue?vue&type=template&id=cfc47544&scoped=true&"
import script from "./CallRecordingActionButtons.vue?vue&type=script&lang=ts&"
export * from "./CallRecordingActionButtons.vue?vue&type=script&lang=ts&"
import style0 from "./CallRecordingActionButtons.vue?vue&type=style&index=0&id=cfc47544&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc47544",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VContainer,VIcon,VRow,VTooltip})
